module.exports = __webpack_public_path__ + "static/media/externalVideoIcon.bb5f839a.svg";